import { onReady } from '../lib/on-ready.js';

function initImageCtaGrid() {
    document.querySelectorAll('.image-cta-grid-component').forEach((component) => {
        const loadMore = component.querySelector('.load-more');
        if (!loadMore) {
            return;
        }

        loadMore.addEventListener('click', (event) => {
            event.preventDefault();
            for (let i = 0; i <= 5; i++) {
                const cell = component.querySelector(`.load-more-cell:nth-child(${i + 1})`);
                if (cell) {
                    cell.style.display = 'block';
                } else {
                    loadMore.style.display = 'none';
                    break;
                }
            }
        });
    });
}

onReady(initImageCtaGrid);
